/**
 * Firebase Storage URL helper.
 *
 * The mechanic app + inspections sometimes persists Firebase Storage paths
 * as `gs://` URIs (Firebase SDK convention) or as `storage.googleapis.com`
 * URLs. Neither is directly loadable by an `<img>` or `<video>` tag in
 * the browser — they must be rewritten to the Firebase Storage download
 * API endpoint: `https://firebasestorage.googleapis.com/v0/b/{bucket}/o/{encodedPath}?alt=media`
 *
 * Pass-through for inputs that are already in download-URL form, plain
 * HTTPS, blob:, or data:.
 */
export function toFirebaseDownloadUrl(url) {
  if (!url || typeof url !== "string") return url;
  // Already a Firebase Storage download URL
  if (url.includes("firebasestorage.googleapis.com/v0/")) return url;
  // storage.googleapis.com/{bucket}/{path} → Firebase download URL
  if (url.includes("storage.googleapis.com/")) {
    try {
      const u = new URL(url);
      const parts = u.pathname.split("/").filter(Boolean);
      if (parts.length >= 2) {
        const bucket = parts[0];
        const objectPath = parts.slice(1).join("/");
        const encoded = encodeURIComponent(objectPath);
        return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encoded}?alt=media`;
      }
    } catch (_e) {
      /* fall through */
    }
  }
  // gs://bucket/path → Firebase download URL
  if (url.startsWith("gs://")) {
    const withoutGs = url.replace("gs://", "");
    const bucket = withoutGs.split("/")[0];
    const objectPath = withoutGs.split("/").slice(1).join("/");
    const encoded = encodeURIComponent(objectPath);
    return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encoded}?alt=media`;
  }
  return url;
}
